<template>
  <div class="c-survey__inner">
    <div
      class="c-survey__content c-survey__content--padding c-survey__content--white-bg"
    >
      <main v-html="intro.content" class="c-survey__html"></main>
      <div
        class="c-survey__actionbutton-row c-survey__actionbutton-row--center"
      >
        <ActionButton
          :title="intro.prevLabel"
          :buttonAction="'prev'"
          :arrowUp="true"
          :muted="true"
        ></ActionButton>
        <ActionButton
          :title="intro.nextLabel"
          :buttonAction="'next'"
          :arrowDown="true"
        ></ActionButton>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import ActionButton from "../ActionButton.vue";

export default {
  created() {},
  computed: {
    ...mapFields(["content.pages.intro"]),
  },
  components: { ActionButton },
  mounted() {},
  methods: {},
};
</script>
